import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  async function isVideo(url: string, timeoutTime?: number): Promise<boolean> {
    // https://stackoverflow.com/questions/9714525/javascript-image-url-verify
    // https://stackoverflow.com/questions/60819889/how-to-check-using-javascript-if-url-contains-video-but-not-audio-or-audio-bu
    const IS_VIDEO = "success";
    const IS_NOT_VIDEO = "error";
    const IS_TIMEOUT = "timeout";

    const video = document.createElement("video");
    const checkIsVideo = new Promise((resolve, reject) => {
      const timeout = timeoutTime || 5000;

      video.setAttribute("src", url);
      let timer = document.createElement("video") as any;

      video.addEventListener("canplay", () => {
        clearTimeout(timer);
        resolve(IS_VIDEO);
      });

      video.addEventListener("error", () => {
        clearTimeout(timer);
        reject(new Error(IS_NOT_VIDEO));
      });

      timer = setTimeout(() => {
        reject(new Error(IS_TIMEOUT));
      }, timeout);
    });

    try {
      const resultIsVideo = await checkIsVideo;
      if (resultIsVideo === IS_VIDEO) {
        return true;
      }

      return false;
    } catch {
      return false;
    }
  }

  return {
    isVideo,
  };
}
